import { FC } from 'react'
import { DemoHead } from 'client/contents/DemoPageContent /components/DemoHead/DemoHead'
import { DemoLayout } from 'client/contents/DemoPageContent /components/DemoLayout/DemoLayout'
import { DemoSuccessPageContent } from 'client/contents/DemoSuccessPageContent/DemoSuccessPageContent'

type TProps = {}

const DemoSuccessPage: FC<TProps> = ({}) => {
  return (
    <article className="flex h-full w-full flex-col bg-surface-white">
      <DemoHead />
      <DemoSuccessPageContent />
    </article>
  )
}

// @ts-expect-error
DemoSuccessPage.layout = (page) => <DemoLayout>{page}</DemoLayout>

export default DemoSuccessPage
